import {
	buildMobileLabels,
	transformLabels
} from 'src/apps/mobile-common/helpers/MobileLabelsHelper';
import {
	IMobileSdkTestRow,
	TMobileSdkTestsResult
} from 'src/apps/mobile-sdk/types/MobileSdkServiceTypes';
import { getFirstStringValue, returnNonNull, toStringArray } from 'src/common/helpers/ArraysHelper';
import { MOBILE_SDK_TYPES_MAP } from 'src/common/helpers/MobileQueriesHelper';

import { MobileSdkTestsQuery } from '../MobileSdkTests.generated';

export const transformMobileSdkTestsResults = (
	result: MobileSdkTestsQuery
): TMobileSdkTestsResult => {
	const tests = result.msdk_report_runs?.filter(returnNonNull) || [];
	const total = result.total?.[0]?.run_id_count || 0;
	const unfilteredTotal = result.unfiltered_total?.[0]?.run_id_count || 0;

	const transformedRows: IMobileSdkTestRow[] = tests.map((test) => {
		const allLabels = transformLabels(test.custom_fields, buildMobileLabels(test));

		return {
			runId: test.run_id ?? '',
			testName: getFirstStringValue(test.test_name),
			totalIssues: test.total_issues ?? 0,
			criticalIssues: test.critical_issues ?? 0,
			testDate: test.run_time,
			totalScans: test.total_scans ?? 0,
			labels: allLabels,
			platform: toStringArray(test.os),
			appName: getFirstStringValue(test.app),
			appVersion: getFirstStringValue(test.app_version),
			sdkType: MOBILE_SDK_TYPES_MAP[test.sdk_type] ?? '',
			productVersion: getFirstStringValue(test.product_version)
		};
	});

	return {
		rows: transformedRows,
		total,
		unfilteredTotal
	};
};
